import React, { useState, useEffect } from "react";
import { Button, Warning} from "@onegovbugs/onegov-react-components";
import classes from "./LogoutConfirmation.module.scss";
import {saveApplication} from "../../../redux/actions";
import {getUrlWithStepNumber} from "../../../utils/NavigationHelper";
import { useDispatch} from "react-redux";
import Cancel from "@material-ui/icons/Cancel";

const LogoutConfirmation = props => {
    const {onLogoutClick, onClickClose} = props;
    const dispatch = useDispatch();


  return (
    <div className={classes.mainCont}>
      <div className={classes.popupOuter}>
        <div className={classes.popupInner}>
          <div className={classes.popupFilter}>
                <h2
                >Logout</h2>
                <div onClick={onClickClose} className={classes.cancelButton}>
                  Close
                  <Cancel name="cancelButton"></Cancel>
                </div>
                <h3>
                  Do you want to save application and logout?                  
                </h3>

                <div className={"row " + classes.topMargin128}>
                  <div className={"col-12"}>
                    <Button
                    onClick={() => {
                        dispatch(
                          saveApplication(getUrlWithStepNumber(window.location.pathname), () => {
                            onLogoutClick()
                          })
                        );
                      }}
                    >
                    Save & Logout
                    </Button>
                    <Button secondary 
                    onClick={() => {
                        onLogoutClick()
                      }}
                    >
                      Logout
                    </Button>
                  </div>
                </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmation;
